<template>
  <v-card>
    <v-card-title class="title">
      Access Prohibited
    </v-card-title>
    <v-divider />
    <v-card-text>
      <v-icon>mdi-lock</v-icon>
      You do not have permission to access this page.  Please see your club's administrator to adjust your permissions.
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'NoAccess',
  data () {
    return {
    }
  }
}
</script>

<style>

</style>
